import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActiontrackerService } from '../actiontracker/services/actiontracker.service';
import { ObservationService } from '../observation/services/observation.service';
import { HseErrorHandlerService } from '../shared/services/hse-error-handler.service';
import { SharedModule } from '../shared/shared.module';
import { IncidentDashboardComponent } from './components/incident-dashboard/incident-dashboard.component';
import { RaiseIncidentComponent } from './components/raise-incident/raise-incident.component';
import { IncidentRoutingModule } from './incident-routing.module';
import { IncidentConstantsService } from './services/incident-constants-service';
import { IncidentService } from './services/incident.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IncidentRoutingModule
  ],
  declarations: [
    RaiseIncidentComponent,
    IncidentDashboardComponent
  ],
  providers: [
    // BaseService,
    ObservationService,
    HseErrorHandlerService,
    IncidentConstantsService,
    IncidentService,
    ActiontrackerService
  ]
})

export class IncidentModule { }
